// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","button":"button","error":"error","primary":"primary","secondary":"secondary","disabled":"disabled","SourceGroup":"SourceGroup","readFullLink":"readFullLink","sourceWrapper":"sourceWrapper","sourceItem":"sourceItem","imageHolder":"imageHolder","noWrap":"noWrap","ObituaryRight":"ObituaryRight"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/SourceGroup/css/SourceGroup.styl
// module id = 625
// module chunks = 0